/* @generated from adl module AppEvents */

import * as ADL from './runtime/adl';
import * as Buffer from './Buffer';
import * as ClientState from './ClientState';
import * as CodeDiagnostics from './CodeDiagnostics';
import * as FileTreeView from './FileTreeView';
import * as InfoRequest from './InfoRequest';
import * as PluginTypes from './PluginTypes';
import * as SyntaxHighlighting from './SyntaxHighlighting';
import * as Terminal from './Terminal';

export interface AppEvent_FileTreeViewRefreshed {
  kind: 'fileTreeViewRefreshed';
  value: FileTreeViewRefreshed;
}
export interface AppEvent_EditorFileOpened {
  kind: 'editorFileOpened';
  value: EditorFileOpened;
}
export interface AppEvent_EditorTabClosed {
  kind: 'editorTabClosed';
  value: EditorTabClosed;
}
export interface AppEvent_EditorFileBufferChanged {
  kind: 'editorFileBufferChanged';
  value: EditorFileBufferChanged;
}
export interface AppEvent_EditorFileSyntaxHighlighting {
  kind: 'editorFileSyntaxHighlighting';
  value: EditorFileSyntaxHighlighting;
}
export interface AppEvent_PluginCodeDiagnosticsUpdate {
  kind: 'pluginCodeDiagnosticsUpdate';
  value: PluginCodeDiagnosticsUpdate;
}
export interface AppEvent_InfoRequestResultEvent {
  kind: 'infoRequestResultEvent';
  value: InfoRequestResultEvent;
}
export interface AppEvent_InfoRequestRegistration {
  kind: 'infoRequestRegistration';
  value: InfoRequestRegistration;
}
export interface AppEvent_TerminalCreated {
  kind: 'terminalCreated';
  value: TerminalCreated;
}
export interface AppEvent_TerminalOutputEvent {
  kind: 'terminalOutputEvent';
  value: TerminalOutputEvent;
}

export type AppEvent = AppEvent_FileTreeViewRefreshed | AppEvent_EditorFileOpened | AppEvent_EditorTabClosed | AppEvent_EditorFileBufferChanged | AppEvent_EditorFileSyntaxHighlighting | AppEvent_PluginCodeDiagnosticsUpdate | AppEvent_InfoRequestResultEvent | AppEvent_InfoRequestRegistration | AppEvent_TerminalCreated | AppEvent_TerminalOutputEvent;

export interface AppEventOpts {
  fileTreeViewRefreshed: FileTreeViewRefreshed;
  editorFileOpened: EditorFileOpened;
  editorTabClosed: EditorTabClosed;
  editorFileBufferChanged: EditorFileBufferChanged;
  editorFileSyntaxHighlighting: EditorFileSyntaxHighlighting;
  pluginCodeDiagnosticsUpdate: PluginCodeDiagnosticsUpdate;
  infoRequestResultEvent: InfoRequestResultEvent;
  infoRequestRegistration: InfoRequestRegistration;
  terminalCreated: TerminalCreated;
  terminalOutputEvent: TerminalOutputEvent;
}

export function makeAppEvent<K extends keyof AppEventOpts>(kind: K, value: AppEventOpts[K]) { return {kind, value}; }

const AppEvent_AST : ADL.ScopedDecl =
  {"moduleName":"AppEvents","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"fileTreeViewRefreshed","default":{"kind":"nothing"},"name":"fileTreeViewRefreshed","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"AppEvents","name":"FileTreeViewRefreshed"}},"parameters":[]}},{"annotations":[],"serializedName":"editorFileOpened","default":{"kind":"nothing"},"name":"editorFileOpened","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"AppEvents","name":"EditorFileOpened"}},"parameters":[]}},{"annotations":[],"serializedName":"editorTabClosed","default":{"kind":"nothing"},"name":"editorTabClosed","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"AppEvents","name":"EditorTabClosed"}},"parameters":[]}},{"annotations":[],"serializedName":"editorFileBufferChanged","default":{"kind":"nothing"},"name":"editorFileBufferChanged","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"AppEvents","name":"EditorFileBufferChanged"}},"parameters":[]}},{"annotations":[],"serializedName":"editorFileSyntaxHighlighting","default":{"kind":"nothing"},"name":"editorFileSyntaxHighlighting","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"AppEvents","name":"EditorFileSyntaxHighlighting"}},"parameters":[]}},{"annotations":[],"serializedName":"pluginCodeDiagnosticsUpdate","default":{"kind":"nothing"},"name":"pluginCodeDiagnosticsUpdate","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"AppEvents","name":"PluginCodeDiagnosticsUpdate"}},"parameters":[]}},{"annotations":[],"serializedName":"infoRequestResultEvent","default":{"kind":"nothing"},"name":"infoRequestResultEvent","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"AppEvents","name":"InfoRequestResultEvent"}},"parameters":[]}},{"annotations":[],"serializedName":"infoRequestRegistration","default":{"kind":"nothing"},"name":"infoRequestRegistration","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"AppEvents","name":"InfoRequestRegistration"}},"parameters":[]}},{"annotations":[],"serializedName":"terminalCreated","default":{"kind":"nothing"},"name":"terminalCreated","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"AppEvents","name":"TerminalCreated"}},"parameters":[]}},{"annotations":[],"serializedName":"terminalOutputEvent","default":{"kind":"nothing"},"name":"terminalOutputEvent","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"AppEvents","name":"TerminalOutputEvent"}},"parameters":[]}}]}},"name":"AppEvent","version":{"kind":"nothing"}}};

export const snAppEvent: ADL.ScopedName = {moduleName:"AppEvents", name:"AppEvent"};

export function texprAppEvent(): ADL.ATypeExpr<AppEvent> {
  return {value : {typeRef : {kind: "reference", value : snAppEvent}, parameters : []}};
}

export interface FileTreeViewRefreshed {
  fileTreeView: FileTreeView.FileTreeView;
}

export function makeFileTreeViewRefreshed(
  input: {
    fileTreeView: FileTreeView.FileTreeView,
  }
): FileTreeViewRefreshed {
  return {
    fileTreeView: input.fileTreeView,
  };
}

const FileTreeViewRefreshed_AST : ADL.ScopedDecl =
  {"moduleName":"AppEvents","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"fileTreeView","default":{"kind":"nothing"},"name":"fileTreeView","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"FileTreeView","name":"FileTreeView"}},"parameters":[]}}]}},"name":"FileTreeViewRefreshed","version":{"kind":"nothing"}}};

export const snFileTreeViewRefreshed: ADL.ScopedName = {moduleName:"AppEvents", name:"FileTreeViewRefreshed"};

export function texprFileTreeViewRefreshed(): ADL.ATypeExpr<FileTreeViewRefreshed> {
  return {value : {typeRef : {kind: "reference", value : snFileTreeViewRefreshed}, parameters : []}};
}

export interface EditorFileOpened {
  editorFile: ClientState.EditorFile;
}

export function makeEditorFileOpened(
  input: {
    editorFile: ClientState.EditorFile,
  }
): EditorFileOpened {
  return {
    editorFile: input.editorFile,
  };
}

const EditorFileOpened_AST : ADL.ScopedDecl =
  {"moduleName":"AppEvents","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"editorFile","default":{"kind":"nothing"},"name":"editorFile","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ClientState","name":"EditorFile"}},"parameters":[]}}]}},"name":"EditorFileOpened","version":{"kind":"nothing"}}};

export const snEditorFileOpened: ADL.ScopedName = {moduleName:"AppEvents", name:"EditorFileOpened"};

export function texprEditorFileOpened(): ADL.ATypeExpr<EditorFileOpened> {
  return {value : {typeRef : {kind: "reference", value : snEditorFileOpened}, parameters : []}};
}

export interface EditorTabClosed {
  id: ClientState.EditorFileId;
}

export function makeEditorTabClosed(
  input: {
    id: ClientState.EditorFileId,
  }
): EditorTabClosed {
  return {
    id: input.id,
  };
}

const EditorTabClosed_AST : ADL.ScopedDecl =
  {"moduleName":"AppEvents","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"id","default":{"kind":"nothing"},"name":"id","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ClientState","name":"EditorFileId"}},"parameters":[]}}]}},"name":"EditorTabClosed","version":{"kind":"nothing"}}};

export const snEditorTabClosed: ADL.ScopedName = {moduleName:"AppEvents", name:"EditorTabClosed"};

export function texprEditorTabClosed(): ADL.ATypeExpr<EditorTabClosed> {
  return {value : {typeRef : {kind: "reference", value : snEditorTabClosed}, parameters : []}};
}

export interface EditorFileBufferChanged {
  id: ClientState.EditorFileId;
  version: ClientState.EditorFileVersion;
  changes: Buffer.BufferChange[];
}

export function makeEditorFileBufferChanged(
  input: {
    id: ClientState.EditorFileId,
    version: ClientState.EditorFileVersion,
    changes: Buffer.BufferChange[],
  }
): EditorFileBufferChanged {
  return {
    id: input.id,
    version: input.version,
    changes: input.changes,
  };
}

const EditorFileBufferChanged_AST : ADL.ScopedDecl =
  {"moduleName":"AppEvents","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"id","default":{"kind":"nothing"},"name":"id","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ClientState","name":"EditorFileId"}},"parameters":[]}},{"annotations":[],"serializedName":"version","default":{"kind":"nothing"},"name":"version","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ClientState","name":"EditorFileVersion"}},"parameters":[]}},{"annotations":[],"serializedName":"changes","default":{"kind":"nothing"},"name":"changes","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"Buffer","name":"BufferChange"}},"parameters":[]}]}}]}},"name":"EditorFileBufferChanged","version":{"kind":"nothing"}}};

export const snEditorFileBufferChanged: ADL.ScopedName = {moduleName:"AppEvents", name:"EditorFileBufferChanged"};

export function texprEditorFileBufferChanged(): ADL.ATypeExpr<EditorFileBufferChanged> {
  return {value : {typeRef : {kind: "reference", value : snEditorFileBufferChanged}, parameters : []}};
}

export interface EditorFileSyntaxHighlighting {
  id: ClientState.EditorFileId;
  version: ClientState.EditorFileVersion;
  spans: SyntaxHighlighting.SyntaxHighlightingSpan[];
}

export function makeEditorFileSyntaxHighlighting(
  input: {
    id: ClientState.EditorFileId,
    version: ClientState.EditorFileVersion,
    spans: SyntaxHighlighting.SyntaxHighlightingSpan[],
  }
): EditorFileSyntaxHighlighting {
  return {
    id: input.id,
    version: input.version,
    spans: input.spans,
  };
}

const EditorFileSyntaxHighlighting_AST : ADL.ScopedDecl =
  {"moduleName":"AppEvents","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"id","default":{"kind":"nothing"},"name":"id","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ClientState","name":"EditorFileId"}},"parameters":[]}},{"annotations":[],"serializedName":"version","default":{"kind":"nothing"},"name":"version","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ClientState","name":"EditorFileVersion"}},"parameters":[]}},{"annotations":[],"serializedName":"spans","default":{"kind":"nothing"},"name":"spans","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"SyntaxHighlighting","name":"SyntaxHighlightingSpan"}},"parameters":[]}]}}]}},"name":"EditorFileSyntaxHighlighting","version":{"kind":"nothing"}}};

export const snEditorFileSyntaxHighlighting: ADL.ScopedName = {moduleName:"AppEvents", name:"EditorFileSyntaxHighlighting"};

export function texprEditorFileSyntaxHighlighting(): ADL.ATypeExpr<EditorFileSyntaxHighlighting> {
  return {value : {typeRef : {kind: "reference", value : snEditorFileSyntaxHighlighting}, parameters : []}};
}

export interface PluginCodeDiagnosticsUpdate {
  pluginName: string;
  workspaceVersion: PluginTypes.WorkspaceVersion;
  codeDiagnostics: CodeDiagnostics.CodeDiagnostic[];
  complete: boolean;
}

export function makePluginCodeDiagnosticsUpdate(
  input: {
    pluginName: string,
    workspaceVersion: PluginTypes.WorkspaceVersion,
    codeDiagnostics: CodeDiagnostics.CodeDiagnostic[],
    complete: boolean,
  }
): PluginCodeDiagnosticsUpdate {
  return {
    pluginName: input.pluginName,
    workspaceVersion: input.workspaceVersion,
    codeDiagnostics: input.codeDiagnostics,
    complete: input.complete,
  };
}

const PluginCodeDiagnosticsUpdate_AST : ADL.ScopedDecl =
  {"moduleName":"AppEvents","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"pluginName","default":{"kind":"nothing"},"name":"pluginName","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[],"serializedName":"workspaceVersion","default":{"kind":"nothing"},"name":"workspaceVersion","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"PluginTypes","name":"WorkspaceVersion"}},"parameters":[]}},{"annotations":[],"serializedName":"codeDiagnostics","default":{"kind":"nothing"},"name":"codeDiagnostics","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"CodeDiagnostics","name":"CodeDiagnostic"}},"parameters":[]}]}},{"annotations":[],"serializedName":"complete","default":{"kind":"nothing"},"name":"complete","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}}]}},"name":"PluginCodeDiagnosticsUpdate","version":{"kind":"nothing"}}};

export const snPluginCodeDiagnosticsUpdate: ADL.ScopedName = {moduleName:"AppEvents", name:"PluginCodeDiagnosticsUpdate"};

export function texprPluginCodeDiagnosticsUpdate(): ADL.ATypeExpr<PluginCodeDiagnosticsUpdate> {
  return {value : {typeRef : {kind: "reference", value : snPluginCodeDiagnosticsUpdate}, parameters : []}};
}

export interface InfoRequestRegistration {
  id: InfoRequest.InfoRequestId;
  infoRequest: InfoRequest.InfoRequest;
}

export function makeInfoRequestRegistration(
  input: {
    id: InfoRequest.InfoRequestId,
    infoRequest: InfoRequest.InfoRequest,
  }
): InfoRequestRegistration {
  return {
    id: input.id,
    infoRequest: input.infoRequest,
  };
}

const InfoRequestRegistration_AST : ADL.ScopedDecl =
  {"moduleName":"AppEvents","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"id","default":{"kind":"nothing"},"name":"id","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"InfoRequest","name":"InfoRequestId"}},"parameters":[]}},{"annotations":[],"serializedName":"infoRequest","default":{"kind":"nothing"},"name":"infoRequest","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"InfoRequest","name":"InfoRequest"}},"parameters":[]}}]}},"name":"InfoRequestRegistration","version":{"kind":"nothing"}}};

export const snInfoRequestRegistration: ADL.ScopedName = {moduleName:"AppEvents", name:"InfoRequestRegistration"};

export function texprInfoRequestRegistration(): ADL.ATypeExpr<InfoRequestRegistration> {
  return {value : {typeRef : {kind: "reference", value : snInfoRequestRegistration}, parameters : []}};
}

export interface InfoRequestResultEvent {
  id: InfoRequest.InfoRequestId;
  infoRequestResult: InfoRequest.InfoRequestResult;
}

export function makeInfoRequestResultEvent(
  input: {
    id: InfoRequest.InfoRequestId,
    infoRequestResult: InfoRequest.InfoRequestResult,
  }
): InfoRequestResultEvent {
  return {
    id: input.id,
    infoRequestResult: input.infoRequestResult,
  };
}

const InfoRequestResultEvent_AST : ADL.ScopedDecl =
  {"moduleName":"AppEvents","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"id","default":{"kind":"nothing"},"name":"id","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"InfoRequest","name":"InfoRequestId"}},"parameters":[]}},{"annotations":[],"serializedName":"infoRequestResult","default":{"kind":"nothing"},"name":"infoRequestResult","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"InfoRequest","name":"InfoRequestResult"}},"parameters":[]}}]}},"name":"InfoRequestResultEvent","version":{"kind":"nothing"}}};

export const snInfoRequestResultEvent: ADL.ScopedName = {moduleName:"AppEvents", name:"InfoRequestResultEvent"};

export function texprInfoRequestResultEvent(): ADL.ATypeExpr<InfoRequestResultEvent> {
  return {value : {typeRef : {kind: "reference", value : snInfoRequestResultEvent}, parameters : []}};
}

export interface TerminalCreated {
  id: ClientState.TerminalId;
  termSurface: Terminal.TermSurface;
}

export function makeTerminalCreated(
  input: {
    id: ClientState.TerminalId,
    termSurface: Terminal.TermSurface,
  }
): TerminalCreated {
  return {
    id: input.id,
    termSurface: input.termSurface,
  };
}

const TerminalCreated_AST : ADL.ScopedDecl =
  {"moduleName":"AppEvents","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"id","default":{"kind":"nothing"},"name":"id","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ClientState","name":"TerminalId"}},"parameters":[]}},{"annotations":[],"serializedName":"termSurface","default":{"kind":"nothing"},"name":"termSurface","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"Terminal","name":"TermSurface"}},"parameters":[]}}]}},"name":"TerminalCreated","version":{"kind":"nothing"}}};

export const snTerminalCreated: ADL.ScopedName = {moduleName:"AppEvents", name:"TerminalCreated"};

export function texprTerminalCreated(): ADL.ATypeExpr<TerminalCreated> {
  return {value : {typeRef : {kind: "reference", value : snTerminalCreated}, parameters : []}};
}

export interface TerminalOutputEvent {
  id: ClientState.TerminalId;
  termSurfaceChange: Terminal.TermSurfaceChange;
}

export function makeTerminalOutputEvent(
  input: {
    id: ClientState.TerminalId,
    termSurfaceChange: Terminal.TermSurfaceChange,
  }
): TerminalOutputEvent {
  return {
    id: input.id,
    termSurfaceChange: input.termSurfaceChange,
  };
}

const TerminalOutputEvent_AST : ADL.ScopedDecl =
  {"moduleName":"AppEvents","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"id","default":{"kind":"nothing"},"name":"id","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ClientState","name":"TerminalId"}},"parameters":[]}},{"annotations":[],"serializedName":"termSurfaceChange","default":{"kind":"nothing"},"name":"termSurfaceChange","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"Terminal","name":"TermSurfaceChange"}},"parameters":[]}}]}},"name":"TerminalOutputEvent","version":{"kind":"nothing"}}};

export const snTerminalOutputEvent: ADL.ScopedName = {moduleName:"AppEvents", name:"TerminalOutputEvent"};

export function texprTerminalOutputEvent(): ADL.ATypeExpr<TerminalOutputEvent> {
  return {value : {typeRef : {kind: "reference", value : snTerminalOutputEvent}, parameters : []}};
}

export const _AST_MAP: { [key: string]: ADL.ScopedDecl } = {
  "AppEvents.AppEvent" : AppEvent_AST,
  "AppEvents.FileTreeViewRefreshed" : FileTreeViewRefreshed_AST,
  "AppEvents.EditorFileOpened" : EditorFileOpened_AST,
  "AppEvents.EditorTabClosed" : EditorTabClosed_AST,
  "AppEvents.EditorFileBufferChanged" : EditorFileBufferChanged_AST,
  "AppEvents.EditorFileSyntaxHighlighting" : EditorFileSyntaxHighlighting_AST,
  "AppEvents.PluginCodeDiagnosticsUpdate" : PluginCodeDiagnosticsUpdate_AST,
  "AppEvents.InfoRequestRegistration" : InfoRequestRegistration_AST,
  "AppEvents.InfoRequestResultEvent" : InfoRequestResultEvent_AST,
  "AppEvents.TerminalCreated" : TerminalCreated_AST,
  "AppEvents.TerminalOutputEvent" : TerminalOutputEvent_AST
};
